<template>
    <v-container v-if="user && user.role === 'admin'">
        <v-row>
            <v-col>
                <redirect-banks-edit-card v-if="$route.name === 'redirect-banks-edit'" />
                <redirect-banks-card v-else />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import RedirectBanksCard from "./cards/redirect-banks-card";
import RedirectBanksEditCard from "./cards/redirect-banks-edit-card";
import { mapState } from "vuex";
import router from "@/router";
export default {
    name: "general-settings-view",
    components: { RedirectBanksCard, RedirectBanksEditCard },

    mounted() {
        if (this.user.role !== "admin") router.push("/admin/landing");
    },
    computed: { ...mapState(["user"]) }
};
</script>

<style scoped></style>
